import { useState } from "react";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPalette } from "@fortawesome/free-solid-svg-icons";

const RGBtoHEX = () => {
  const [rgb, setRgb] = useState({ r: "", g: "", b: "" });
  const { darkMode } = useTheme();
  const [hex, setHex] = useState("");

  const handleRgbChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = value.replace(/\s+/g, "");
    
    if (cleanedValue === "" || (/^\d*$/.test(cleanedValue) && parseInt(cleanedValue) >= 0 && parseInt(cleanedValue) <= 255)) {
      const newRgb = { ...rgb, [name]: cleanedValue };
      setRgb(newRgb);
      
      if (newRgb.r && newRgb.g && newRgb.b) {
        try {
          const r = parseInt(newRgb.r).toString(16).padStart(2, "0");
          const g = parseInt(newRgb.g).toString(16).padStart(2, "0");
          const b = parseInt(newRgb.b).toString(16).padStart(2, "0");
          setHex(`#${r}${g}${b}`.toUpperCase());
        } catch {
          setHex("Invalid RGB values");
        }
      } else {
        setHex("");
      }
    }
  };

  return (
    <>
      <HeaderSection toolId="rgbToHex" />
      <div className="max-w-4xl mx-auto p-4 lg:max-w-full lg:px-4 dark:text-white">
        <div className="bg-white rounded-xl dark:bg-gray-800 shadow-sm dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 overflow-hidden">
          <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
            <h1 className="text-2xl font-bold mb-2 flex items-center">
              <FontAwesomeIcon icon={faPalette} className="mr-3" />
              RGB to HEX Color Converter
            </h1>
            <p className="opacity-90">
              Convert RGB color values to hexadecimal representation
            </p>
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
            >
              RGB Values (0-255)
            </label>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <input
                  type="text"
                  name="r"
                  value={rgb.r}
                  onChange={handleRgbChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Red"
                />
              </div>
              <div>
                <input
                  type="text"
                  name="g"
                  value={rgb.g}
                  onChange={handleRgbChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Green"
                />
              </div>
              <div>
                <input
                  type="text"
                  name="b"
                  value={rgb.b}
                  onChange={handleRgbChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Blue"
                />
              </div>
            </div>
          </div>

          <div className="p-6">
            <label
              className="block text-gray-700 dark:text-gray-200 mb-2"
            >
              HEX Color
            </label>
            <textarea
              value={hex}
              readOnly
              rows={2}
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-100 font-mono"
            />
          </div>

          {hex && !hex.includes("Invalid") && (
            <div className="p-6 pt-0">
              <label
                className="block text-gray-700 dark:text-gray-200 mb-2"
              >
                Color Preview
              </label>
              <div
                className="w-full h-12 rounded-md border border-gray-300 dark:border-gray-600"
                style={{ backgroundColor: hex }}
              ></div>
            </div>
          )}
        </div>
      </div>
      <BottomSection toolId="rgbToHex" />
    </>
  );
};

export default RGBtoHEX;